import { createSelector } from 'reselect'

export const getQuery = createSelector(
  state => state && state.user && state.user.list && state.user.list.query ? state.user.list.query : null,
  query => query
)
